import React from 'react'
import PaginaTed from '../../../components/acesso-rapido/transferir/pagina-ted/PaginaTed'

const PaginaTedInicial = () => {
  return (<PaginaTed/>)
}

export default PaginaTedInicial
